export default "__VITE_ASSET__CPr41gAV__"